import { Container } from '@patsnap/tahiti-core/shared/inversify';
import { baseModule } from '@/container-modules/base-module';
import { headerServiceModule } from '@/container-modules/header-service-module';
import { serviceApiModule } from '@/container-modules/service-api-module';
import { errorHandlerModule } from '@/container-modules/error-handler-module';
import { businessModule } from '@/container-modules/business-module';
import { autoMountModule } from './container-modules/auto-mount-module';
import { feedbackModule } from './container-modules/feedback-module';
import { shareLinkModule } from './container-modules/share-link-module';
import { featurePermissionModule } from './container-modules/feature-permission-module';
import { specificationModule } from './domains/specification';
import { translateBotModule } from './domains/translate-bot';
import { spiltEditorServiceModule } from '@telecom/shared/components/spilt-editor';
import { popoverModule } from '@telecom/shared/services/popover';
import { classificationModule } from '@telecom/shared/modules/classification-module';
import { disclosureModule } from '@/domains/disclosure/index';
import { homeModule } from '@/domains/home';
import { sharedModules } from './container-modules/shared-module';
import { trackerModule } from '@/container-modules/tracker-module';
import { wireFrameExtractDialogModule } from './services/wire-frame-extract-dialog';
import { cacheRestoreServiceModule } from './container-modules/cache-restore-service-module';
import { freeTrailModule } from '@/presentation/components/free-trail';
import { noveltySearchInputStateModule } from '@/services/novelty-search-input-state';
import { googleTagManagerModule } from './container-modules/google-tag-manager-module';
import { loginModule } from '@/features/login';
import { guestModule } from '@/domains/guest';
import { noveltyCheckSearchContainer } from '@/presentation/pages/novelty-check-report/novelty-check-search-container';
import { ftoSearchContainer } from '@/presentation/pages/fto-pro/fto-search-container';

const container = new Container({
    defaultScope: 'Singleton',
    skipBaseClassChecks: true,
});

container.load(
    baseModule,
    trackerModule,
    googleTagManagerModule, // 加载 Google Tag Manager 服务模块
    ...sharedModules,
    autoMountModule,
    feedbackModule,
    shareLinkModule, // 加载分享链接模块
    featurePermissionModule, // 加载功能权限模块
    headerServiceModule,
    serviceApiModule,
    errorHandlerModule,
    businessModule,
    cacheRestoreServiceModule, // 加载缓存恢复服务模块
    specificationModule,
    translateBotModule,
    spiltEditorServiceModule,
    popoverModule,
    disclosureModule,
    homeModule,
    classificationModule,
    wireFrameExtractDialogModule,
    freeTrailModule, // 加载免费试用对话框模块
    noveltySearchInputStateModule, // 加载查新检索输入状态服务模块
    loginModule, // 加载登录对话框模块
    guestModule, // 加载游客任务迁移模块
    noveltyCheckSearchContainer, // 加载查新检索搜索模块
    ftoSearchContainer, // 加载 FTO 搜索模块
);

export {
    container,
};
